import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import {
  fn,
  handleFulfilled,
  handleFulfilledAdd,
  handleFulfilledDelete,
  handleFulfilledGet,
  handlePending,
  handleRejected,
  handleFulfilledUpdate,
} from 'services/functionSlice';
import { initialContacts } from './initialState';
import {
  addContactThunk,
  deleteContactThunk,
  getContactsThunk,
  updateContactThunk,
} from './thunk';

const contactsSlice = createSlice({
  name: 'contacts',
  initialState: initialContacts,
  extraReducers: builder => {
    builder
      .addCase(getContactsThunk.fulfilled, handleFulfilledGet)
      .addCase(addContactThunk.fulfilled, handleFulfilledAdd)
      .addCase(deleteContactThunk.fulfilled, handleFulfilledDelete)
      .addCase(updateContactThunk.fulfilled, handleFulfilledUpdate)
      .addMatcher(isAnyOf(...fn('pending')), handlePending)
      .addMatcher(isAnyOf(...fn('rejected')), handleRejected)
      .addMatcher(isAnyOf(...fn('fulfilled')), handleFulfilled);
  },
});

export const contactsReducer = contactsSlice.reducer;
